import { z } from 'zod';

export const validateAuthDomainSchema = z.object({
  email: z.string().email(),
});
export type ValidateAuthDomainInput = z.infer<typeof validateAuthDomainSchema>;

export const validateAuthDomainResponseSchema = z.object({
  allowed: z.boolean(),
});
export type ValidateAuthDomainResponse = z.infer<typeof validateAuthDomainResponseSchema>;

export const meResponseSchema = z.object({
  uid: z.string(),
  email: z.string().email(),
  displayName: z.string().nullable(),
  photoURL: z.string().url().nullable(),
  role: z.enum(['admin', 'user', 'ceo', 'viewer']),
  area: z.string().nullable(),
  /**
   * Whether this user's email is in the CEO_EMAILS allowlist on the server.
   * Drives the disabled-state of the "CEO" option in the area picker on the
   * onboarding dialog. Server-side enforcement happens at write time too.
   */
  canPickCeoArea: z.boolean(),
  /**
   * Metric Hub reviewer flag. True iff the user has area = 'DATA' AND
   * `users/{uid}.reviewer === true`. Drives reviewer-only UI affordances.
   * Server still enforces this at write time on every decision endpoint.
   * Defaults to `false` so legacy frontends / the Chrome extension that
   * don't read this field continue to work unchanged.
   */
  reviewer: z.boolean().default(false),
  /**
   * Whether this user receives Metric Hub notifications as Slack DMs (in
   * addition to the in-app bell). Defaults to `true`; the user can opt out
   * from their profile. Legacy docs without the field rehydrate to `true`.
   */
  slackNotificationsEnabled: z.boolean().default(true),
});
export type MeResponse = z.infer<typeof meResponseSchema>;
